// MARK: NPM Modules
import React, { useState } from "react";
import styled from "styled-components";
// MARK: Types
import Poster from "types/fields/entries/poster";

// MARK: Styled Components
const Container = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

interface MediaProps {
	borderradius?: number;
}

const FloatingPoster = styled.img<MediaProps>`
	position: absolute;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: ${({ borderradius }) => (borderradius ? borderradius : 0)}px;
`;

const StyledVideo = styled(({ ...props }) => (
	<video
		autoPlay
		playsInline
		muted
		loop
		preload="preload"
		loading="lazy"
		{...props}
	/>
))<MediaProps>`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: ${({ borderradius }) => (borderradius ? borderradius : 0)}px;
`;

// MARK: React Component
// Props
interface Props {
	src: string;
	poster: Poster;
	borderradius?: number;
	altText: string;
}
// Component

const AutoPlayLoopingVideo = ({
	src,
	poster,
	borderradius,
	altText,
}: Props) => {
	// MARK: State Variables
	const [canPlay, setCanPlay] = useState<boolean>(false);
	// MARK: Functionality
	const renderPoster = () => {
		switch (canPlay) {
			case true:
				return "";
			case false:
				return (
					<FloatingPoster
						src={poster[0].url}
						borderradius={borderradius}
						alt={altText}
						loading="lazy"
					/>
				);
		}
	};
	// MARK: Render
	return (
		<Container>
			{renderPoster()}
			<StyledVideo
				src={src}
				borderradius={borderradius}
				onCanPlay={() => {
					setCanPlay(true);
				}}
			/>
		</Container>
	);
};

export default AutoPlayLoopingVideo;
